import { render, staticRenderFns } from "./CategoryIndexView.vue?vue&type=template&id=9574f0ba&scoped=true"
import script from "./CategoryIndexView.vue?vue&type=script&lang=js"
export * from "./CategoryIndexView.vue?vue&type=script&lang=js"
import style0 from "./CategoryIndexView.vue?vue&type=style&index=0&id=9574f0ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9574f0ba",
  null
  
)

export default component.exports